export const EXPIRY_DATE_TYPES = {
  SPECIFIC_DATE: "Specific date",
  END_OF_CURRENT_YEAR: "End of  current year",
  NUMBER_OF_DAYS: "Number of days",
  USE_PRE_GENERATED: "Use pre generated",
  NO_EXPIRY_DATE: "No expiry date",
};
